export default __webpack_public_path__ + "static/media/SportsBanner.612002e6.jpg";